import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { installiereMock } from './api/mock';
import { ToastBereich } from './components/ui';
import './styles.css';

// Mock-Schicht vor dem ersten fetch einhängen (Modi: api/mock/index.ts).
installiereMock();

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastBereich>
          <App />
        </ToastBereich>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
